<template>
  <v-card flat>
    <v-card-text>
      <v-row :dense="isMobile()">
        <v-col xl="auto" lg="auto" md="auto" cols="12">
          <v-select
            :items="itens_inf_placa"
            item-text="text"
            label="Informar placa do veículo"
            v-model="informarPlacaModel"
          ></v-select>
        </v-col>
        <template v-if="informar_placa">
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <v-form ref="form">
              <v-text-field
                label="Placa"
                v-mask="'AAA-#N##'"
                v-model="placaModel"
                :rules="[(v) => !!v || 'Informe a placa']"
                @keyup.enter="pesquisarVeiculo()"
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
            <v-btn
              rounded
              color="info"
              small
              depressed
              :block="isMobile()"
              @click="pesquisarVeiculo()"
              :loading="veiculo.carregando"
              >Buscar veículo</v-btn
            >
          </v-col>
          <v-col cols="12">
            <v-row dense>
              <v-col cols="12" v-if="veiculo.msgErro != ''">
                <v-alert type="error" text>{{ veiculo.msgErro }}</v-alert>
              </v-col>
              <v-col
                xl="auto"
                lg="auto"
                md="auto"
                cols="12"
                v-else-if="veiculo.dados"
              >
                <v-card flat rounded="lg" class="grey lighten-3">
                  <v-card-title class="font-weight-bold">{{
                    veiculo.dados.descricao
                  }}</v-card-title>
                  <v-card-subtitle>{{
                    veiculo.dados.nome_transportador
                  }}</v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        Capacidade do veículo
                      </v-col>
                    </v-row>
                    <v-row dense>                      
                      <v-col
                        xl="auto"
                        lg="auto"
                        md="auto"
                        cols="6"
                        v-for="(cx, i) in veiculo.dados.caixas"
                        :key="i"
                      >                      
                        <caixa-capacidade-produto :caixa="cx" />
                      </v-col>
                    </v-row>
                  </v-card-text>                  
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <btn-avancar-form-carga v-if="!informar_placa || veiculo.dados" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import BtnAvancarFormCarga from './BtnAvancarFormCarga.vue';
import CaixaCapacidadeProduto from "./CaixaCapacidadeProduto.vue";
export default {
  components: { CaixaCapacidadeProduto, BtnAvancarFormCarga },
  computed: {
    ...mapState("formacaoCarga", ["informar_placa", "placa", "veiculo"]),
    informarPlacaModel: {
      get: function () {
        return this.informar_placa;
      },
      set: function (value) {
        this.setInformarPlaca(value);
        if (!value) this.setPlaca("");
      },
    },
    placaModel: {
      get: function () {
        return this.placa;
      },
      set: function (value) {
        return this.setPlaca(value.toUpperCase());
      },
    },
  },
  data: () => ({
    itens_inf_placa: [
      { text: "Sim", value: true },
      { text: "Não", value: false },
    ],
  }),
  methods: {
    ...mapMutations("formacaoCarga", [
      "setInformarPlaca",
      "setPlaca",      
    ]),
    ...mapActions("formacaoCarga", ["buscarVeiculo"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async pesquisarVeiculo() {
      if (this.$refs.form.validate()) {
        await this.buscarVeiculo();
      }
    },
  },
};
</script>

<style>
</style>